export default function Marker(props: any) {
	return (
		<div className="position-absolute" style={{ transform: "translate(-50%, -50%)", ...props.style }}>
			{props.children}
		</div>
	);
}
